import React, { FC, memo } from 'react';

import classNames from 'classnames';
import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';

import { DATA_TEST_IDS } from '../consts';
import type { AudioReportActionButtonsProps } from './types';

import styles from './index.module.scss';

const AudioReportActionButtons: FC<AudioReportActionButtonsProps> = ({
  cancelButtonElementId = DATA_TEST_IDS.REPORT_CANCEL_BUTTON,
  cancelButtonClassName,
  closeButtonText,
  isRequestDisabled,
  isRequestLoading,
  requestButtonText,
  submitButtonElementId = DATA_TEST_IDS.REPORT_SUBMIT_BUTTON,
  submitButtonClassName,
  onClose,
  onRequestSubmit,
}) => (
  <>
    <Button
      elementId={cancelButtonElementId}
      type={ButtonType.SECONDARY}
      className={classNames(styles.button, cancelButtonClassName)}
      onClick={onClose}>
      {closeButtonText}
    </Button>
    <Button
      elementId={submitButtonElementId}
      type={ButtonType.PRIMARY}
      className={classNames(styles.button, submitButtonClassName)}
      isLoading={isRequestLoading}
      isDisabled={isRequestDisabled}
      onClick={onRequestSubmit}>
      {requestButtonText}
    </Button>
  </>
);

export default memo(AudioReportActionButtons);
